import React, { useState, useEffect,useLayoutEffect } from "react";
//import {createRoot} from "react-dom/client";
import "./SearchResults.css";
const SearchResults =(props) =>{
  //  const ref = React.useRef(null);
  const [searchVal,setSearchVal]= useState('');
    useEffect(()=>{
        AssignSearchStylesClasses();
        PasteSearchTerm();
    },[]);
     const AssignSearchStylesClasses=()=>{
         let classResults= document.getElementsByClassName("custom-mashan-results");
         if(classResults.length>0){
            classResults[classResults.length-1].classList.add('custom-mashan-results-lastchild');
         }
        //  let upLinkTop = document.getElementById('UpScopeLinkTop');
        //  if(!!upLinkTop){
        //     upLinkTop.classList.add("d-none");
        //  }
         let tempPageMashanImageText = document.getElementsByClassName("pageMashanImageText");
         tempPageMashanImageText.length>0 ? tempPageMashanImageText[0].classList.add("search-page-addclass"):null;

         let tempMainPage2 = document.getElementById("main-page-2");
         !!tempMainPage2 ? tempMainPage2.classList.add("search-page-addclass"):null;
     };
     const PasteSearchTerm=()=>{
        let searchArr= location.href.split("k=");
        let searchStr='';
        if(searchArr.length>1){
            setSearchVal(searchArr[1]);
        }
     };
     setTimeout(()=>{
         AssignSearchStylesClasses();
     },250);
     const HandleKeyDownSearchPage =(eve)=>{
            if(eve.key==='Enter'){
                ExecuteSearchSearchPage( eve.target.value);
            }
     };
     const HandleKeyDownGlassSearchPage =(eve)=>{
               if(eve.key==='Enter'){
                   ExecuteSearchSearchPage( eve.target.previousElementSibling.value);
               }
        };
    return <div id={'search-results-key'}  className={'search-results-warpper col-12'} > 
                <div className="search col-11 col-lg-8 d-flex">
            <input
                type="search"
                className="col-12 searchpage-box-input" id="search-box-input" onKeyDown={e => { HandleKeyDownSearchPage(e) }} tabIndex="0" defaultValue={searchVal} />
                        <a type="search" className="searchpage-box-glass" onClick={e=>{ExecuteSearchSearchPage(e.target.previousElementSibling.value)}} 
                            onKeyDown={e=>{HandleKeyDownGlassSearchPage(e)}} tabIndex="0"></a>
                        <i className="fa fa-times far take-me-2-end" onClick={e=>{ClearSearchSearchPage(e)}} tabIndex="0"></i>
                </div>
            </div>
}


export default SearchResults;